import { render, staticRenderFns } from "./SystemSettingsIndex.vue?vue&type=template&id=416bff80&scoped=true"
import script from "./SystemSettingsIndex.vue?vue&type=script&lang=js"
export * from "./SystemSettingsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416bff80",
  null
  
)

export default component.exports